

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { StateList } from "../../components/StateList";


export const StateListPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="State List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "State List", navigateTo: "/state/list" }
      ]}
      mainContents={<StateList />}
    />
  );
};
